import { render, staticRenderFns } from "./saasAgreement.vue?vue&type=template&id=10a80bef&scoped=true"
import script from "./saasAgreement.vue?vue&type=script&lang=js"
export * from "./saasAgreement.vue?vue&type=script&lang=js"
import style0 from "./saasAgreement.vue?vue&type=style&index=0&id=10a80bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a80bef",
  null
  
)

export default component.exports